import * as React from 'react';

import '../Main.scss';

import {
    Input,
    Row,
    Col
} from 'reactstrap';

import { GetUnsafeContentMessage } from '../../Utils/FormUtils';
import { DangerousInput } from './DangerousInputForm';

import { PortalTextCommon } from '../../Models/Api/strongbox.financialportal';

type Props = {
    id: string;
    name: string;
    nameForInvalidMsg: string;
    value?: string;
    maxLength?: number;
    clearFieldWithDangerousContent: () => void;
    updateField: (newValue: string) => void;
    fieldWithDangerousContent?: DangerousInput;
    required?: boolean;
    autoFocus?: boolean;
    commonText?: PortalTextCommon;
};

export const PotentiallyDangerousInput: React.FC<Props> = (props): React.ReactElement => {
    const {
        id,
        name,
        value,
        clearFieldWithDangerousContent,
        updateField,
        maxLength,
        fieldWithDangerousContent,
        nameForInvalidMsg,
        required,
        autoFocus,
        commonText,
    } = props;

    const invalidMsg = React.useMemo(() => {
        return GetUnsafeContentMessage(nameForInvalidMsg, commonText);
        
        // This is the appropriate list of dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [nameForInvalidMsg]);

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Input
                        type={'text'}
                        id={id}
                        name={name}
                        value={value}
                        onChange={(e) => {
                            clearFieldWithDangerousContent();
                            updateField(e.currentTarget.value);
                        }}
                        required={!!required}
                        autoFocus={!!autoFocus}
                        maxLength={maxLength}
                    />
                </Col>
                {
                    !!fieldWithDangerousContent && (fieldWithDangerousContent.fieldId === id) && (
                        <Row>
                            <Col>
                                <span className={'error-text'}>{invalidMsg}</span>
                            </Col>
                        </Row>
                    )
                }
            </Row>
        </React.Fragment>
    );
}
